__turbopack_context__.v({
  "caption": "HIHImageCaption-module-scss-module__p-PW3W__caption",
  "captionOverlay": "HIHImageCaption-module-scss-module__p-PW3W__captionOverlay",
  "image": "HIHImageCaption-module-scss-module__p-PW3W__image",
  "imageBox": "HIHImageCaption-module-scss-module__p-PW3W__imageBox",
  "imageCaption": "HIHImageCaption-module-scss-module__p-PW3W__imageCaption",
});
